<div class="container">
    <div *ngIf="isLoading" class="row center">
        <div class="spinner-border text-danger" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div *ngIf="!isLoading" class="row">
        <div class="col-md-8">
            <div class="panel panel-default">
                <div class="panel-heading">Add Manual Match</div>
                <div class="panel-body">
                    <form [formGroup]="matchForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label>Event Id</label>
                            <input formControlName="eventId" type="text" class="form-control"
                                placeholder="Enter Event Id">
                            <div class="error" *ngIf="submitted && f.eventId.errors">
                                <div class="text-danger" *ngIf="f.eventId.errors.required">Event Id is required</div>
                                <div class="text-danger" *ngIf="f.eventId.errors.pattern">Numeric Value Only</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Market Id</label>
                            <input formControlName="marketId" type="text" class="form-control"
                                placeholder="Enter Market Id">
                            <div class="error" *ngIf="submitted && f.marketId.errors">
                                <div class="text-danger" *ngIf="f.marketId.errors.required">Market Id is required</div>
                                <div class="text-danger" *ngIf="f.marketId.errors.pattern">Numeric Value Only</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Event Name</label>
                            <input formControlName="eventName" type="text" class="form-control" aria-describedby="match"
                                placeholder="Enter Event Name">
                            <div class="error" *ngIf="submitted && f.eventName.errors">
                                <div class="text-danger" *ngIf="f.eventName.errors.required">Event Name is
                                    required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Open Date</label>
                            <input formControlName="openDate" type="datetime-local" class="form-control"
                                placeholder="Enter OpenDate">
                            <div class="error" *ngIf="submitted && f.openDate.errors">
                                <div class="text-danger" *ngIf="f.openDate.errors.required">openDate is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Select Event Type</label>
                            <select (change)="setRunners($event.target.value)" formControlName="matchType"
                                class="form-control">
                                <option value="">Select</option>
                                <option value="OneDay">OneDay</option>
                                <option value="T20">T20</option>
                                <option value="Test">Test</option>
                            </select>
                            <div class="error" *ngIf="submitted && f.matchType.errors">
                                <div class="text-danger" *ngIf="f.matchType.errors.required">Event Type is required
                                </div>
                            </div>
                        </div>
                        <div *ngIf="runnerToggle" class="form-group">
                            <label>Runner 1</label>
                            <input formControlName="runner1" type="text" class="form-control"
                                placeholder="Enter Runner 1">
                            <div class="error" *ngIf="submitted && f.runner1.errors">
                                <div class="text-danger" *ngIf="f.runner1.errors.required">Runner1 is required</div>
                            </div>
                        </div>
                        <div *ngIf="runnerToggle" class="form-group">
                            <label>Runner 2</label>
                            <input formControlName="runner2" type="text" class="form-control"
                                placeholder="Enter Runner 2">
                            <div class="error" *ngIf="submitted && f.runner2.errors">
                                <div class="text-danger" *ngIf="f.runner2.errors.required">Runner2 is required</div>
                            </div>
                        </div>
                        <div *ngIf="testToggle" class="form-group">
                            <label>Runner 3</label>
                            <input formControlName="runner3" type="text" class="form-control"
                                placeholder="Enter Runner 3">
                            <div class="error" *ngIf="submitted && f.runner3.errors">
                                <div class="text-danger" *ngIf="f.runner3.errors.required">Runner3 is required</div>
                            </div>
                        </div>
                        <button [disabled]="submitted && matchForm.invalid" type="submit"
                            class="btn btn-primary">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>